export default __webpack_public_path__ + "static/media/creativee-04--removebg-preview.35d57062.png";